import styled from 'styled-components';
import colors from '@designSystem/colors';

export const PaginationContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  justify-content: center;
  margin: 24px 0px;

  color: ${colors.black};
`;

export const BoldSpan = styled.span`
  font-weight: 500;
`;

export const NavigationIconContainer = styled.div`
  padding: 16px;
  cursor: pointer;
`;

export const PageInput = styled.input`
  text-align: center;
  background-color: ${colors.lightGrey};
  border: 1.5px solid ${colors.grey};
  box-sizing: border-box;
  border-radius: 8px;
  width: 50px;
  height: 40px;
`;

export const ContainerWithMargin = styled.div`
  margin: 0px 16px;
`;
